import type { Direction } from "@/components/layout/Flex";

export const directionPaddingMap: Record<Direction, string> = {
  row: "p-4 md:p-6 lg:p-8",
  column: "p-4 md:p-6 lg:p-8",
  "row-reverse": "p-4 md:p-6",
  "column-reverse": "p-4 md:p-6 lg:p-8",
};
